import React from 'react';
import { useSelector } from 'react-redux';

import useFetch from '@api/hooks/useFetch';
import AccountClientRequests from '@api/requests';

import {
	getBranchEnvironment,
	getIsBranchEnvironmentUpdated,
} from '@app/redux/branchEnvironment/branchEnvironment.selectors';

import { Grid } from '@mui/material';

import Loader from '@components/loader';

function ResourcesProvider({ children }: { children: JSX.Element }) {
	const authFormSlug = useSelector(getBranchEnvironment).auth_form_slug;
	const isBranchEnvironmentUpdated = useSelector(getIsBranchEnvironmentUpdated);
	const { loading: isLoadingCountriesList } = useFetch(AccountClientRequests.Assets.getCountriesList, [], undefined);
	const { loading: isLoadingStatesList } = useFetch(AccountClientRequests.Assets.getStatesList, [], undefined);
	const { loading: isLoadingAuthFormBySlug } = useFetch(
		AccountClientRequests.AuthForms.getAuthFormBySlug,
		[authFormSlug],
		{ slug: authFormSlug },
		{ skip: !isBranchEnvironmentUpdated },
	);

	return isLoadingStatesList || isLoadingCountriesList || isLoadingAuthFormBySlug ? (
		<Grid container alignItems={'center'} justifyContent={'center'} sx={{ height: '100vh' }}>
			<Loader />
		</Grid>
	) : (
		children
	);
}

export default ResourcesProvider;
